import { inject, Injectable } from '@angular/core';
import { SwitchingAccountDisplay } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { HeaderFooterMachCoreContentService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { InterstitialAdapterService } from '../../adapters/interstitial/interstitial-adapter.service';
import { SwitchingAccountService } from '../../services/switching-account/switching-account.service';

@Injectable({
  providedIn: 'root'
})
export class InterstitialFacadeService {
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  adapter = inject(InterstitialAdapterService);
  switchingAccountService = inject(SwitchingAccountService);
  switchingAccountDetails$ = new BehaviorSubject<SwitchingAccountDisplay>(
    {} as SwitchingAccountDisplay
  );

  init(isDesktop: boolean): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((content) => {
        this.switchingAccountDetails$.next(
          this.adapter.getContent(content, isDesktop)
        );
      });
  }
}
